import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Store } from '@ngxs/store';
import { Observable, filter, map, of, takeUntil } from 'rxjs';
import { decode as decodeHtml } from 'html-entities';
import { Request } from 'express';

import { BrandCampaign } from '@hiptraveler/data-access/api';
import { BrandState } from '@hiptraveler/data-access/brand';
import { SearchState } from '@hiptraveler/data-access/search';
import { currentLang, getLocationData } from '@hiptraveler/common';
import * as Feature from '@hiptraveler/features/meta-tag';

@Injectable()
export class SearchAndDefaultPageObserverService {

  constructor(
    @Optional() @Inject(REQUEST) private request: Request,
    @Inject(PLATFORM_ID) private platformId: Object,
    private store: Store,
    private metaTagService: Feature.MetaTagService
  ) { }

  get originalUrl(): string {
    return (this.request?.originalUrl || getLocationData()?.pathname).split('?')[0].split('#')[0];
  }

  get rootConfig$(): Observable<Feature.ObserverConfig> {

    const brandCampaignConfig = Feature.getDefaultBrandNameConfig();
    if (brandCampaignConfig) return of(brandCampaignConfig);

    return this.store.select(BrandState.brandCampaign).pipe(
      filter(Boolean),
      map((brandCampaign: Partial<BrandCampaign>) => Feature.getConfigByBrandCampaign(brandCampaign)),
      takeUntil(this.metaTagService.subscription$)
    );
  }

  get locationChanges$(): Observable<Feature.Metadata | null> {
    return this.store.select(SearchState.locationData).pipe(
      map(locationData => (locationData ? {
        imageUrl: locationData?.coverImg?.imgUrl,
        description: decodeHtml(locationData?.description || Feature.defaultMetaTagData.description),
        callback: {
          location: locationData?.city
        }
      } as Feature.Metadata : locationData)),
      takeUntil(this.metaTagService.subscription$)
    );
  }

  get config$(): Observable<Feature.ObserverConfig> {
    return this.metaTagService.imgUrl$.pipe(
      map((imageUrl: string) => {
        
        const serverConfigUrl = this.originalUrl;
        const serverConfig = { url: serverConfigUrl, lang: Feature.serverLang(serverConfigUrl) };
        const browserConfig = { url: getLocationData()?.pathname, lang: currentLang() };
        const config = isPlatformServer(this.platformId) ? serverConfig : browserConfig;

        return { metadata: { imageUrl }, ...config } as Feature.ObserverConfig;
      }),
      takeUntil(this.metaTagService.subscription$)
    )
  }

}
